import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { AdditionalServiceVoice } from '@sales/modules/subscription/models/additional-service-voice.model';
import { FormStatus } from '@sales/models/form-status.enum';
import { SimCardDelivery, SimCardType } from '@sales/models/simcard.model';
import { PriceFormatPipe, PriceType } from '@shared/pipes/price-format.pipe';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IceRadioButtonComponent } from '@app/shared/components/atoms/ice-radio-button/ice-radio-button.component';
import { IceSelectBoxComponent } from '@app/shared/components/molecules/ice-select-box/ice-select-box.component';
import { IceInputFieldComponent } from '@app/shared/components/molecules/ice-input-field/ice-input-field.component';
import { FormValidationService } from '@app/shared/services/form-validation.service';
import { SubscriptionHelperService } from '@sales/services/subscription-helper.service';

@Component({
  selector: 'app-additional-sim',
  templateUrl: './additional-sim.component.html',
  styleUrls: ['./additional-sim.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [
    ReactiveFormsModule,
    IceSelectBoxComponent,
    IceRadioButtonComponent,
    IceInputFieldComponent,
    SpinnerComponent,
    AsyncPipe,
    PriceFormatPipe,
  ],
})
export class AdditionalSimComponent {
  private formGroupDirective = inject(FormGroupDirective);

  FormStatus = FormStatus;
  SimCardDelivery = SimCardDelivery;
  PriceType = PriceType;
  getSimCardErrorTexts = FormValidationService.getSimCardErrorTexts;

  service = input.required<AdditionalServiceVoice>();
  label = input.required<string>();
  instanceId = input.required<string>();
  readonly = input(false);

  simCardType = computed(() => (this.service().isTwinSimCard ? SimCardType.Twin : SimCardType.Data));
  monthlyPrice = computed(() => this.service().price?.includingVAT);
  isActive = computed(() => SubscriptionHelperService.isServiceActive(this.service()));
  activeIcc = computed(() => (this.isActive() ? this.service().icc : ''));

  get selectionControl(): FormControl {
    return this.formGroupDirective.form.get('selected') as FormControl;
  }

  get iccField(): FormControl {
    return this.formGroupDirective.form.get('icc') as FormControl;
  }

  get isSelected(): boolean {
    return !!this.selectionControl.value;
  }

  get isDeliveredInStore(): boolean {
    return this.formGroupDirective.form.get('simDelivery')?.value === SimCardDelivery.InStore;
  }
}
